import React from 'react'
import { Box, Button, Typography } from '@mui/material';

const CustomButton = ({label,icon,onClick,length}) => {
  return (
           <Box
          sx={{ 
            padding: 2,
            borderRadius: 3,
            display: 'inline-block',
            width:"100%"
          }}
        >
          <Button
            variant="contained"
            disableElevation
            fullWidth
            onClick={onClick}
            sx={{
              backgroundColor: 'white',
              borderRadius: 3,
              boxShadow: 6,
              color: 'black',
              textTransform: 'none',
              padding: 2,
              justifyContent: 'flex-start',
              '&:hover': {
                backgroundColor: '#ffff',
              },
            }}
            startIcon={
              <Box
                sx={{
                  backgroundColor: '#a1d42b',
                  padding: 1,
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: 40,
                  minHeight: 40,
                }}
              >
                {icon}
              </Box>
            }
          >
            <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%"}}  >
              <Box>
            <Typography variant="h6" sx={{ color: '#002144' }}>
              {label}
            </Typography>
            </Box>
            {length>0&&(
              <Box sx={{border:"solid 1px #000"}} p={0.4} px={2} borderRadius={1} >
                <Typography variant="h6" sx={{ color: '#002144' }}>
              {length}
            </Typography>
                </Box>
            )}
            </Box>
          </Button>
        </Box>
  )
}

export default CustomButton